import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import styles from './index.module.scss';

export const DownloadPopup = ({ submit }) => {
  const downloadTypeHandler = value => {
    submit(value.target.textContent);
  };

  return (
    <form className={styles.form}>
      <div className={styles.btnContainer}>
        <div className={styles.btn}>
          <Button
            type="button"
            text={'CSV'}
            onClick={downloadTypeHandler}
            size="l"
          />
        </div>
        <div className={styles.btn}>
          <Button
            type="button"
            text={'PDF'}
            onClick={downloadTypeHandler}
            size="l"
          />
        </div>
      </div>
    </form>
  );
};

DownloadPopup.propTypes = {
  submit: PropTypes.func,
};
